import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

const sidebarItems = [
  { href: "/dashboard", label: "Overview", section: "Wallets" },
  { href: "/dashboard/fund-wallet/cash-deposit", label: "Cash Deposit", section: "Fund Wallet"},
  { href: "/dashboard/fund-wallet/bank-transfer", label: "Bank Transfer", section: "Fund Wallet" },
  { href: "/dashboard/transfers/other-wallet", label: "Other Wallet", section: "Transfers" },
  { href: "/dashboard/transfers/wallet-to-bank", label: "Wallet-to-Bank", section: "Transfers" },
  { href: "/dashboard/payments/airtime", label: "Airtime", section: "Payments" },
  { href: "/dashboard/payments/electricity", label: "Electricity", section: "Payments" },
  { href: "/dashboard/payments/data", label: "Data", section: "Payments" },
  { href: "/settings", label: "Settings", section: "Settings" },
];

function SideBar() {
  const showSideBar = useSelector((state) => state.showSideBar.value);
  const user = useSelector((state) => state.user.user);
  const history = useHistory();
  const location = useLocation();
  const pathName = location.pathname;

  const handleSignout = () => {
    localStorage.clear();
    history.push("/login");
  };

  const getPathNameBadge = (path) => {
    return pathName === path ? (
      <span className="badge rounded-pill bg-primary ms-auto align-self-center">
        {"  "}
      </span>
    ) : null;
  };

  // Group items by section
  const groupedItems = {};
  sidebarItems.forEach((item) => {
    if (!groupedItems[item.section]) {
      groupedItems[item.section] = [];
    }
    groupedItems[item.section].push(item);
  });

  return (
    <div className="col-12 col-lg-3 col-xl-2 px-lg-0 border-bottom border-bottom-lg-0 border-end-lg border-gray-300 sidenav sidenav-start">
      <div
        className={`collapse d-lg-block ${showSideBar ? "show" : ""}`}
        id="sidenavCollapse"
      >
        <div className="py-7 py-lg-9 px-lg-5">
          {Object.keys(groupedItems).map((section) => (
            <div key={section}>
              <h6 className="text-uppercase fw-bold">{section}</h6>
              <ul className="list mb-6">
                {groupedItems[section].map((item) => (
                  <li className="list-item" key={item.href}>
                    <a className="list-link" href={item.href}>
                      {item.label}
                      {getPathNameBadge(item.href)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <hr />
          <div>
            <span
              className="text-danger fw-bold"
              style={{ cursor: "pointer" }}
              onClick={handleSignout}
            >
              Signout{"  "}
              <span className="fe fe-power"></span>
            </span>
          </div>

          <div className="row align-items-center mt-3">
            <div className="col-auto">
              <div className="avatar avatar-lg mb-3 ms-3">
                {user.photo_url ? (
                  <img
                    className="avatar-img rounded-circle w-120 h-120"
                    src={user.photo_url}
                    alt="User Avatar"
                  />
                ) : (
                  <span className="avatar-title rounded-circle text-uppercase">{`${user.first_name[0]}${user.last_name[0]}`}</span>
                )}
              </div>

              <div className="col auto">
                <p className="mb-0 fw-bolder">{`${user.first_name} ${user.last_name}`}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
